import { render, staticRenderFns } from "./CreateArticleView.vue?vue&type=template&id=724e0aaa&"
import script from "./CreateArticleView.vue?vue&type=script&lang=js&"
export * from "./CreateArticleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports